import type { Embed } from 'types/capi/content';

import EmbedComponent from '~/components/Content/Embed';

type Props = {
  embed: Embed;
};

export default function EmbedBlock({ embed }: Props) {
  return (
    <div className="flex w-full items-center justify-center">
      <div className="flex w-[323px] flex-col gap-6 md:w-[552px]">
        <EmbedComponent embed={embed} />
      </div>
    </div>
  );
}
